import createStore from "astrid-helpers/src/createStore";

export const [getMuteStudio, setMuteStudio, useMuteStudio] = createStore(false);
